import { AlbatrossTeamIcon, tss } from '@ds/components'
import { ReactElement } from 'react'

const useStyles = tss.create(() => ({
    root: {
        borderRadius: '50%',
        border: '2px solid #ff9e1b',
    },
}))

export function AlbatrossBottomNavIcon(): ReactElement {
    const { classes } = useStyles()

    return <AlbatrossTeamIcon className={classes.root} />
}
